module.exports = __webpack_public_path__ + "static/media/pain.0d1e05f7.jpg";